module.exports = __webpack_public_path__ + "static/brandingsofiamoraes-41e3aaa79a93b0a26b63c5a888453c55.jpeg";